import React, { useEffect } from "react";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";
import DiagnosticsData from "../components/DiagnosticsData";

const Diagnostics = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <DiagnosticsData />
      </div>
    </div>
  );
};

export default Diagnostics;
